import { Add, Delete } from '@mui/icons-material';
import { Box, Button, Grid, IconButton, TextField } from '@mui/material';
import { ChangeEventHandler, useEffect, useState } from 'react';
import { Control, Controller, useFieldArray } from 'react-hook-form';
import { RouteUrls } from '../../../Routes/RouteUrls';
import { useAppSelector } from '../../../Redux/store';

interface ResponsibilitiesProps {
    control: Control<any, any>;
    maxHeight?: string;
}

export const ResponsibilitiesForm = ( { control, maxHeight }: ResponsibilitiesProps ) => {
    /* ******************** Hooks ******************** */
    const { fields, append, remove } = useFieldArray({
        // @ts-ignore
        name: 'responsibilities',
        control
    });
    /* ******************** Variables ******************** */
    const [prefill, setPrefill] = useState('');
    const postingModalOpen = useAppSelector( state => state.JobPostingCreation.isOpen);
    /* ******************** Functions ******************** */
    const handlePrefillChange = (event:any) => {
        setPrefill(event.target.value);
    }
    const handlePrefillClick = () => {
        prefill
        .split(',')
        .forEach( f => {
            append(f.trim())
        })
    }
    /* ******************** Effects ******************** */
    // useEffect(()=>{
    //     if (fields.length === 0) append('');
    // },[]);
    /* ******************** JSX ******************** */
    return (
        <Grid maxHeight={maxHeight ?? '502px'} overflow={postingModalOpen ? '' : 'auto' }>
            <Grid item xs display={"flex"} flexDirection={"column"} gap={1} >
                    <Grid display={"flex"} flexDirection={"row"} gap={2}>
                        <TextField
                            multiline
                            value={prefill}
                            onChange={handlePrefillChange}
                            placeholder='Enter a comma separated list to pre-fill (i.e Manage projects, Marketing)'
                            sx={{flex: 12}}
                        />
                        <Grid item display={"flex"} flex={1} flexDirection={"row"} alignItems={'center'} justifyContent={'flex-end'} gap={1}>
                            <IconButton disabled={prefill.length === 0} onClick={handlePrefillClick}>
                                <Add color={prefill.length > 0 ? 'primary': "secondary"}/>
                            </IconButton>
                        </Grid>
                    </Grid>
                    {
                        fields.map( (field, index) => (
                            <Grid key={field.id} item xs display={"flex"} flexDirection={"column"} gap={1}>
                                <Grid display={"flex"} flexDirection={"row"} gap={2}> 
                                    <Controller 
                                        name={`responsibilities.${index}`}
                                        control={control}
                                        rules={{required: true}}
                                        render={({ field }) =>( 
                                            <TextField
                                                {...field}
                                                multiline
                                                placeholder='Description of responsibility'
                                                sx={{flex: 12}}
                                            />
                                        )}                                    
                                    /> 
                                    <Grid item display={"flex"} flex={1} flexDirection={"row"} alignItems={'center'} justifyContent={'flex-end'} gap={1}>
                                        <Box>
                                            <IconButton onClick={ () => remove(index)}>
                                                <Delete color='error'/>
                                            </IconButton>
                                        </Box>
                                    </Grid>
                                </Grid>    
                            </Grid>
                        ))
                    } 
                    <Grid item display={"flex"} flexDirection={"row"} >
                            <Button color='primary'  onClick={ () => append('')} >
                                <Add fontSize='small' sx={{marginRight: 0.5}}/>Add responsibility
                            </Button> 
                    </Grid>
            </Grid>
        </Grid>
    )
}